<div class="allCta">
  <div class="allCta-text"><div [innerText]="headingText"></div><div [innerText]="headingText2"></div></div>
  <a href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register" class="flowbtn app-btn" [innerText]="regisText"></a>
</div>

<div class="allCta ipad">
  <div class="allCta-text">
    <div [innerText]="headingTextIpad1"></div>
    <div [innerText]="headingTextIpad2"></div>
    <div [innerText]="headingTextIpad3"></div>
  </div>
  <a href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register" class="flowbtn app-btn"
    [innerText]="regisText"></a>
</div>